const filteredModules = [
  'RENT_REPORTING_PREMIUM_UPSELL_BANNER', // this should stop be sending from slapi as soon as apps have all new versions for users
  'CREDIT_BUILDER_MODULE',
  'SUBSCRIPTION_OVERVIEW_BANNER_MODULE',
];

export const evaluateTodayContainerModules = ({
  todayContainerModules,
  plusBannerOverviewWebConfig,
}) => {
  const unifiedEnrollAndPlusBannerModule = {
    module: 'UNIFIED_ENROLL_PLUS_BANNER',
    unifiedModules: [],
  };

  const isNotPremiumAndHasBanner =
    plusBannerOverviewWebConfig?.mainJson?.showBanner;

  const {
    unifiedEnrollModulesIndexList,
    todayContainerWithoutFilteredModules,
  } = todayContainerModules?.reduce(
    (acc, mod, index) => {
      if (filteredModules.includes(mod?.module)) {
        if (mod?.module === 'CREDIT_BUILDER_MODULE') {
          unifiedEnrollAndPlusBannerModule?.unifiedModules?.unshift({
            module: mod?.module,
          });
          acc?.unifiedEnrollModulesIndexList?.push(index);
        }
        if (mod?.module === 'SUBSCRIPTION_OVERVIEW_BANNER_MODULE') {
          acc?.unifiedEnrollModulesIndexList?.push(index);
          if (isNotPremiumAndHasBanner) {
            unifiedEnrollAndPlusBannerModule?.unifiedModules?.unshift({
              module: mod?.module,
              plusBannerOverviewWebConfig,
            });
          }
        }
      } else {
        acc?.todayContainerWithoutFilteredModules.push(mod);
      }

      return acc;
    },
    {
      unifiedEnrollModulesIndexList: [],
      todayContainerWithoutFilteredModules: [],
    },
  );

  if (
    unifiedEnrollModulesIndexList?.length &&
    unifiedEnrollAndPlusBannerModule?.unifiedModules.length > 0
  ) {
    todayContainerWithoutFilteredModules?.splice(
      unifiedEnrollModulesIndexList[0],
      0,
      unifiedEnrollAndPlusBannerModule,
    );
    return todayContainerWithoutFilteredModules;
  } else {
    return todayContainerWithoutFilteredModules;
  }
};
